export default __webpack_public_path__ + "static/media/play_icon.5d662273.svg";